import qs from 'qs';
import { api } from '../../routes/api';

export const requestToLogin = async params => {
  const response = await api.post('/app/covenant/login', qs.stringify(params));
  return response.data;
}


// WEBPACK FOOTER //
// ./src/pages/Login/services.js